import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    content:
      'data-[state=delayed-open]:animate-tooltip-open data-[state=closed]:animate-tooltip-close z-100 overflow-hidden rounded-xl bg-white p-4 shadow-[0px_4px_11px_0px_rgba(29,31,34,0.1)]',
    arrow: 'fill-white'
  }
});
